<template>
    <div >
        <el-card>
            <el-row>
                <el-col :span="24">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                        <el-breadcrumb-item><a @click="goBack">{{title}}</a></el-breadcrumb-item>
                        <el-breadcrumb-item>{{name}}  修改记录</el-breadcrumb-item>
                    </el-breadcrumb>
                </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row>
                <el-col :span="24">
                <el-table :data="tableData" style="width: 100%" v-loading="loading" size="small">
                    <el-table-column prop="SendUserName" label="操作人"></el-table-column>
                    <el-table-column prop="SendTime" label="操作时间"></el-table-column>
                    <el-table-column label="类型"><template slot-scope="scope">{{ scope.row.Type==0?'添加':(scope.row.Type==1?'编辑':'添加') }}</template></el-table-column>
                    <el-table-column prop="AuditUserName" label="审核人"></el-table-column>
                    <el-table-column prop="AuditTime" label="审核时间"></el-table-column>
                </el-table>
                </el-col>
            </el-row>
        </el-card>
    </div >
</template>

<script>
    import { GetEditHistory  } from "../../until/ZeusApiSDK/Logic/WikiLogic";
    import { getUrlKey  } from "../../until/ZeusApiSDK/Logic/ImageStr";
    export default {
        data() {
            return {
                id:'',//当前百科id
                name:'',//当前百科名称
                tableData: [],
                loading:false,
                title:'我的百科',//我的百科
            }
        },
        methods: {
            //获取修改记录
            wikiHistory:function(){
                var paras=[{
                    Field:"AuditStatus", 
                    Value:"2", 
                    Oper:"eq", 
                    IsAnd:1
                },{
                    Field:"KnowledgeID", 
                    Value:this.id, 
                    Oper:"eq", 
                    IsAnd:1
                }];
                GetEditHistory(paras).then(res=>{
                    this.tableData=res;
                });
            },
            //返回上一页
            goBack:function(){
                this.$router.go(-1)
            },
        },
        //页面进入加载事件
        created:function(){
            //获取当前百科id
            this.id=getUrlKey('id');
            //获取当前百科名称
            this.name=getUrlKey('name');
            //头部导航
            this.title=getUrlKey('title');
            //获取修改记录
            this.wikiHistory();
        }
    }
</script>